import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Button,Modal} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import WorkdocStore from 'stores/WorkdocStore'
import { Checkbox } from 'react-icheck'

class TaxinvoiceModal extends Component {

    constructor(props) {
        super(props)

        this.state = {doc:{vat_type:'',amount:0},taxinvoice_lists:[],check_taxinvoice_lists:[],isCheckAll:false}
    }

    componentDidMount() {

    }

    componentWillReceiveProps(newProps) {
        if (newProps.show&&newProps.show!==this.props.show) {
            this.loadData(newProps.tivNo)
        }
    }

    loadData(tivNo) {
		let {genItemlist,docType} = this.props
		WorkdocStore.loadTaxinvoiceDoc(tivNo,(result)=>{
            let check_itemlist = []
            result.data.itemlist.forEach((item,index)=>{
				let checkDup = -1
				if (docType==='creditnote')
					checkDup = genItemlist.findIndex(x=>x.creditnote_no===item.taxinvoice_no)
				else if (docType==='creditnote')
					checkDup = genItemlist.findIndex(x=>x.debitnote_no===item.taxinvoice_no)		
				
                if (checkDup===-1) {
                    check_itemlist.push({isCheck:false,bf_taxinvoice_item_id:item.bf_taxinvoice_item_id})
                } else {
                    check_itemlist.push({isCheck:true,bf_taxinvoice_item_id:item.bf_taxinvoice_item_id})
                }
            })
            this.setState({doc:result.data.doc,taxinvoice_lists:result.data.itemlist,check_taxinvoice_lists:check_itemlist})
        })    
    }

    getNumberFormat(value) {
        if(value===''||value===null||value===undefined||isNaN(value)){
          return ''
        }
        let _val = parseFloat(value)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

	onTaxinvoiceChange(index) {
		let {check_taxinvoice_lists} = this.state
		if (check_taxinvoice_lists[index].isCheck)
			check_taxinvoice_lists[index].isCheck = false
		else
			check_taxinvoice_lists[index].isCheck = true
		
		let find = check_taxinvoice_lists.findIndex(x=>x.isCheck===false)
		let check = false
		if (find===-1)
			check = true

		this.setState({check_taxinvoice_lists:check_taxinvoice_lists,isCheckAll:check})
	}

	onTaxinvoiceAllChange() {
		let {isCheckAll,check_taxinvoice_lists} = this.state
		let new_list = []
		if (isCheckAll) {
			new_list = check_taxinvoice_lists.map((item,index)=>{
				item.isCheck = false
				return item
			})
			this.setState({isCheckAll:false})
		} else {
			new_list = check_taxinvoice_lists.map((item,index)=>{
				item.isCheck = true
				return item
			})
			this.setState({isCheckAll:true})
		}
		this.setState({check_taxinvoice_lists:new_list})
	}

	onTaxinvoiceSelect() {
		let {check_taxinvoice_lists,doc,taxinvoice_lists} = this.state
        let items = []
        taxinvoice_lists.forEach((item,index)=>{
            if (check_taxinvoice_lists[index].isCheck)
                items.push(item)
        })
		let datas = {doc:doc,itemlist:items}
		this.setState({isCheckAll:false})
        if (this.props.onItemsSelect!==undefined)
            this.props.onItemsSelect(datas)
	}

    onHide() {
        this.setState({isCheckAll:false})
        this.props.onHide()
    }

    renderTaxinvoiceRowData() {
		let {taxinvoice_lists,check_taxinvoice_lists} = this.state
		if (taxinvoice_lists.length===0) {
			return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
		} else {
			return(
				taxinvoice_lists.map((item,index)=>{
					return(
						<tr key={index}>
							<td className='text-center'>
								<Checkbox
                                    onChange={this.onTaxinvoiceChange.bind(this,index)}
                                    checked={check_taxinvoice_lists[index].isCheck}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={''}
                                >
                                </Checkbox>
							</td>
							<td className='text-left'>{item.detail}</td>
							<td className='text-center'>{item.quantity}</td>
							<td className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
							<td className='text-right'>{this.getNumberFormat(item.amount)}</td>
						</tr>
					)
				})
			)
		}
	}

	renderTaxVatType(vat_type){
	
		if(vat_type=='VAT_INCLUDE'){
			return (<span>VAT ใน</span>)
		}else if(vat_type=='VAT_EXCLUDE'){
			return (<span>VAT นอก</span>)
		}else{
			return (<span>ไม่ทราบ</span>)
		}
	  }

    renderTaxinvoiceTable() {
		let {messages} = this.props
		let {isCheckAll,doc} = this.state
		let beforeVat = doc.amount/1.07
		let vat = doc.amount - beforeVat

		return(
			<div className='table-responsive'>
				<table className='table table-hover table-bordered-solid table-gen-doc' style={{marginBottom:'0'}}>
					<thead>
						<tr>
							<th style={{width:'50px'}} className='text-center'>
								<Checkbox
                                    onChange={this.onTaxinvoiceAllChange.bind(this)}
                                    checked={isCheckAll}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={''}
                                >
                                </Checkbox>
							</th>
                            <th>{messages['Item']}</th>
                            <th className='text-center' style={{width:'90px'}}>{messages['Quantity']}</th>
                            <th className='text-center' style={{width:'120px'}}>{messages['Price/Unit']}</th>
                            <th className='text-center' style={{width:'130px'}}>{messages['Amount']}</th>
						</tr>
					</thead>
					<tbody>
						{this.renderTaxinvoiceRowData()}
					</tbody>
					<tfoot>
						<tr>
							<th colSpan={4} className='text-right'>คิดภาษีแบบ</th>
							<td className='text-right'>{this.renderTaxVatType(doc.vat_type)}</td>
						</tr>
						<tr>
							<th  colSpan={4} className='text-right'>มูลค่าเดิม </th>
							<td className='text-right'>{this.getNumberFormat(doc.amount)}</td>
						</tr>
						<tr>
							<th  colSpan={4} className='text-right'>ยอดรวมก่อนภาษี </th>
							<td className='text-right'>{this.getNumberFormat(beforeVat)}</td>
						</tr>
						<tr>
							<th  colSpan={4} className='text-right'>ภาษีมูลค่าเพิ่ม 7% </th>
							<td className='text-right'>{this.getNumberFormat(vat)}</td>
						</tr>
						<tr>
							<th  colSpan={4} className='text-right'>ยอดรวมสุทธิ </th>
							<td className='text-right'>{this.getNumberFormat(doc.amount)}</td>
						</tr>																		
					</tfoot>
				</table>
			</div>
		)
	}

    render() {
        let {show} = this.props
        return(
            <Modal show={show} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
                <Modal.Header closeButton>
                    <Modal.Title>เลือกรายการจากใบกำกับภาษี</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.renderTaxinvoiceTable()}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.onTaxinvoiceSelect.bind(this)}><FontAwsome name='check' />&nbsp;เลือกรายการ</Button>
                    <Button onClick={this.onHide.bind(this)}><FontAwsome name='close' />&nbsp;ปิด</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}    

TaxinvoiceModal.defaultProps = {
	genItemlist:[]
}

export default TaxinvoiceModal = connect(
    (state) => ({messages: state.message.view.doc.GeneralDoc}),null,null,{withRef:true}
)(TaxinvoiceModal);    



// WEBPACK FOOTER //
// ./src/view/doc/TaxinvoiceModal.js